<template src="./Details.html">
</template>

<script>
export default {
        props: {
            itemId: {
                type: Number,
                required: true,
            },
        },

        created() {
            this.$store
                .dispatch("analysis/getDetails", this.itemId)
                .then(() => {

                })
                .catch(() => { });
        },
        data() {
    return {

   

    };
  },
  computed: {
    analysis() {
          return this.$store.state.analysis.analysis;
      }
  },
};
</script>